module.exports = __webpack_public_path__ + "media/images/how-it-works/directduel/step-6-872a72d24f33e9a8f18024a2b836803b.png";